export default "__VITE_ASSET__COldsYIh__"